import { MailOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Tooltip } from '@side/pantry';
import { TrackDocumentsEvent } from '$analytics/useTrackAnalytics/domains/documents/events';
import { useTrackDocsAnalytics } from '$analytics/useTrackAnalytics/domains/documents/useTrackDocsAnalytics';

export interface Props {
  combined: boolean;
  href: string;
}

export const MailToLink = ({ combined, href }: Props) => {
  const trackEvent = useTrackDocsAnalytics();
  return (
    <Tooltip title="Email Packet">
      <IconButton
        href={href}
        target="_blank"
        onClick={() =>
          trackEvent(TrackDocumentsEvent.CopyLinkViewOfferModal, {
            offer_type: combined ? 'combined' : 'separate',
          })
        }
        aria-label={`Mail ${combined ? 'combined' : 'separate'} offer packet`}
        sx={{
          color: 'primary.main',
          width: 'auto',
        }}
      >
        <MailOutlined />
      </IconButton>
    </Tooltip>
  );
};
